import React from 'react';
import { SPORTS } from 'constants/appConfig';
import footballBg from '../images/sportradar/football_bg_placeholder.jpg';
import redWarmIconImg from '../images/red_warn_icon.png';
import '../css/CommonMatchCenterPlaceholder.css';

const FOOTBALL_HALF_TIME = 45;

const CommonMatchCenterPlaceholder = ({ event }) => {
    return (
        <div className="common-matchcenter-placeholder">
            <div className="top-event-bar">
                <div className="team-label home-label">{event.homeTeam}</div>
                <div className="event-info-container">
                    {event.live && (
                        <React.Fragment>
                            <div className="live-score">
                                {event.liveScore && event.liveScore.homeScore} -{' '}
                                {event.liveScore && event.liveScore.awayScore}
                            </div>
                            <div className="live-time">
                                {event.sportId === SPORTS.FOOTBALL &&
                                event.liveScore.time === FOOTBALL_HALF_TIME
                                    ? 'HT'
                                    : `${event.liveScore.time}'`}
                            </div>
                        </React.Fragment>
                    )}
                    {!event.live && (
                        <React.Fragment>
                            <div className="event-time">
                                {event.kickoffTime}
                            </div>
                            <div className="event-date">
                                {event.kickoffDate}
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className="team-label away-label">{event.awayTeam}</div>
            </div>
            <div className="bg-area">
                {event.sportId === SPORTS.FOOTBALL && (
                    <img src={footballBg} alt="widget background" />
                )}
                <div className="notification-label">
                    <img
                        className="info-img"
                        src={redWarmIconImg}
                        alt="warn icon"
                    />
                    <div>ingen livefeed på denne kamp</div>
                </div>
            </div>
        </div>
    );
};

export default CommonMatchCenterPlaceholder;
